<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" content="聊天好友列表"></el-page-header>

        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">客户类型：</span>
                <el-select class="status" v-model="role_type" placeholder="请选择类型" style="width: 100%; max-width: none !important;">
                    <el-option
                        v-for="item in allRole"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="9" :xl="10" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">日期：</span>
                <el-date-picker
                        v-model="search_expired_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <div style="clear:both;"></div>
        <div id="layout">
            <div id="docker_user">
                <p>{{ user_name }}和{{ friend_name }}的聊天记录</p>
            </div>
            <div id="chat_box">
                <el-table ref="multipleTable"
                          :data="chatList"
                          border
                          :row-class-name="msgTimeoutClass"
                          style="width: 100%">
                    <el-table-column prop="send_user_name" label="消息发送人姓名" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="user_type" label="客户类型" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="message_type" label="消息类型" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="create_date" label="消息发送时间" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="read_text" label="对方是否已读" align="center" label-class-name="label"></el-table-column>
                    <el-table-column prop="read_time" label="消息读取时间" align="center" label-class-name="label"></el-table-column>

                </el-table>
            </div>
        </div>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog title="搜索聊天记录" :visible.sync="dialogFormVisible">
            <div v-for="item in allLogData" style="text-align: left;" @click="onclikLog(item)">
                <span style="font-size: 17px;font-weight: bold;">{{item.user_name}}:</span>
                <span style="margin: 0 0 0 7px;">{{item.value}}</span>
                <el-divider></el-divider>
            </div>

            <el-pagination
                    class="mg-20 ta-r"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10, 25, 50, 100]"
                    :total="logTotal"
                    :page-size="logPerpage"
                    :current-page="logPage"
                    @current-change="logChangePage"
                    @size-change="logChangeSite"
            ></el-pagination>
        </el-dialog>

    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import chatBox from "./chatBox";
    import {isMobile} from "@/api/order";

    export default {
        inject: ['chat_params'],
        data() {
            return {
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                page: 1,
                logPage: 1,
                perpage: 10,
                logPerpage: 10,
                total: 0,
                logTotal: 0,
                tableData: [],
                role_type: '',
                allRole: [
                    {
                        id: 0,
                        name: '全部'
                    },
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                ],
                user_id: '',
                content: '',
                obj_id: '',
                start_date: '',
                end_date: '',
                dialogFormVisible: false,
                search_expired_date: '',
                user_name: '',
                friend_name: '',
                chatList: [],
                allLogData: [],
                doctor_last_id: 0,   // 专家发送的最后一条聊天消息id
                doctor_last_time: 0, // 专家最后一条聊天消息的发送时间
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
            localStorage.setItem('prev_page', 'content_chat_detail')
            this.user_id = this.$route.params.user_id || this.$route.query.user_id;
            this.obj_id = this.$route.params.obj_id || this.$route.query.obj_id;
            this.friend_name = this.$route.params.friend_name || this.$route.query.friend_name;
            this.user_name = this.$route.params.own_name || this.$route.query.own_name;
            // 获取列表
            this.getList();
        },
        mounted() {

        },
        components: {
            chatBox
        },
        methods: {
            msgTimeoutClass({row, rowIndex}) {
                if (row.user_role == 1
                    // && (parseInt(row.msg_id) > parseInt(this.doctor_last_id))
                    && (new Date(row.create_date)).getTime() > (new Date(this.doctor_last_time)).getTime()
                    && (((new Date()).getTime() - row.msg_timestemp) > 1800000 || row.is_notice == 1)) {
                    return 'msg_timeout'
                } else {
                    return ''
                }


            },
            getListLog() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'singleMessageList',
                    pageinfo: {
                        page: this.logPage,
                        perpage: this.logPerpage,
                    },
                    params: {
                        user_id: this.user_id,
                        obj_id: this.obj_id,
                        content: this.content,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        user_role: this.role_type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allLogData = [];
                    var allLogData = res.data.data.list.list;

                    for (var i = 0; i < allLogData.length; i++) {
                        var msg_content = JSON.parse(allLogData[i].msg_content);
                        let obj = {
                            msg_id: allLogData[i].msg_id,
                            user_name: allLogData[i].user_name,
                            value: msg_content.value
                        }
                        this.allLogData.push(obj);
                    }
                    this.dialogFormVisible = true;
                    this.logTotal = res.data.data.page.count;
                    this.logPage = res.data.data.page.page;
                });
            },

            // 点击聊天记录跳转到指定的聊天位置
            onclikLog(data) {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'singleMessageList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        obj_id: this.obj_id,
                        content: data.content,
                        msg_id: data.msg_id,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        user_role: this.role_type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    var friend_id = this.obj_id;
                    let res_data = res.data;
                    this.chatList = [];
                    let chatList = res_data.data.list.list;

                    for (let chat in chatList) {
                        let message = JSON.parse(chatList[chat]['msg_content']);

                        for (let key  in message) {
                            if (key == 'value') {
                                message['value'] = decodeURI(message['value']);

                                switch (message['type']) {
                                    case 'sayText':
                                        // 普通文本
                                        message['value'] = message['value'];
                                        break;
                                    case 'sayImg':
                                        // 发送图片
                                        if (/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);

                                            let valueArray = [];
                                            valueArray.push(message['value']);
                                            message['valueArray'] = valueArray;
                                        }
                                        break;
                                    case 'sayVoice':
                                        // 发送语音
                                        if (/\.(pcm|wav)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);
                                        }
                                        break;
                                    case 'sayHealthRecords':
                                        // 发送健康档案
                                        message['value'] = JSON.parse(message['value']);
                                        break;
                                    case 'sayOther':
                                        // 邀请
                                        message['value'] = JSON.parse(message['value']);
                                        message['value']['value'] = JSON.parse(message['value']['value']);

                                        break;
                                }

                            }
                        }
                        let item = {
                            index: chat,
                            type: chatList[chat]['type'],
                            create_date: chatList[chat]['create_date'],
                            identity: chatList[chat]['form_user_id'] == friend_id ? 1 : 2,
                            message: message,
                            user_name: chatList[chat].user_name
                        };
                        this.chatList.push(item);
                    }
                    this.total = res_data.data.page.count;
                    this.page = res_data.data.page.page;

                    this.dialogFormVisible = false;
                });
            },

            getList() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'singleMessageList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        obj_id: this.obj_id,
                        content: this.content,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        user_role: this.role_type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    var friend_id = this.obj_id;
                    let res_data = res.data;
                    this.chatList = [];
                    let chatList = res_data.data.list.list;
                    this.doctor_last_id = res_data.data.list.doctor_last_msg_id
                    this.doctor_last_time = res_data.data.list.doctor_last_msg_time
                    for (let i = 0; i < chatList.length; i++) {

                        // 消息发送人
                        chatList[i].send_user_name = chatList[i].send_user_id == this.user_id ? this.user_name : this.friend_name
                        // 客户类型
                        chatList[i].user_type
                        switch (chatList[i].user_role) {
                            case '1':
                                // 普通文本
                                chatList[i].user_type = '特属服务对象';
                                break;
                            case '3':
                                // 发送图片
                                chatList[i].user_type = '特属专家';
                                break;
                        }
                        chatList[i].msg_timestemp = (new Date(chatList[i].create_date)).getTime();
                        // 消息类型
                        switch (chatList[i].type) {
                            case 'sayText':
                                // 普通文本
                                chatList[i].message_type = '文字消息';
                                break;
                            case 'sayImg':
                                // 发送图片
                                chatList[i].message_type = '图片消息';
                                break;
                            case 'sayVoice':
                                // 发送语音
                                chatList[i].message_type = '语音消息';
                                break;
                            case 'sayHealthRecords':
                                // 发送健康档案
                                chatList[i].message_type = '健康档案';
                                break;
                            case 'sayOther':
                                // 邀请
                                chatList[i].message_type = '预约邀请';
                                break;
                        }
                        // 发送时间
                        // 对方是否已读
                        if (chatList[i].is_recall !=1 ) {
                            chatList[i].read_text = chatList[i].is_read == 1 ? '已读' : '未读';
                            // 读取时间
                            chatList[i].read_time = chatList[i].is_read == 1 ? chatList[i].update_date : '未读';
                            // 未回复提醒
                            chatList[i].notice_text = chatList[i].is_notice == 1 ? '已提醒' : '未提醒';
                            if (chatList[i].user_role == 3) {
                                chatList[i].notice_text = '----';
                            }
                        } else {
                            chatList[i].read_text = '消息被撤回';
                            chatList[i].read_time = '----';
                            chatList[i].notice_text = '----';
                        }
                    }
                    this.chatList = chatList
                    this.total = res_data.data.page.count;
                    this.page = res_data.data.page.page;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.content = '';
                this.perpage = index;
                this.getList();
            },

            logChangeSite(index) {
                this.logPerpage = index;
                this.getListLog();
            },

            //更换页码
            changePage(index) {
                this.content = '';
                this.page = index;
                this.getList();
            },

            logChangePage(index) {
                this.logPage = index;
                this.getListLog();
            },

            // 重置按钮
            resetForm() {
                this.content = "";
                this.search_expired_date = "";
                this.start_date = "";
                this.end_date = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (!this.content && !this.search_expired_date) {
                    this.page = 1;
                    this.getList();
                    return;
                }

                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }

                if (this.content) {
                    // 有内容搜索
                    this.logPage = 1;
                    this.getListLog();
                } else {
                    // 没有内容直接调用getList
                    this.page = 1;
                    this.getList();
                }
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        user_id: data.user_id,
                        type: 1
                    }
                });
            },

            // 返回上一页
            goBack() {

                window.history.go(-1);
            },
        },
        watch: {
            $route:{
                immediate:true,
                handler(to, from){
                    if (from) {
                        this.user_id = this.$route.params.user_id || this.$route.query.user_id;
                        this.obj_id = this.$route.params.obj_id || this.$route.query.obj_id;
                        this.friend_name = this.$route.params.friend_name || this.$route.query.friend_name;
                        this.user_name = this.$route.params.own_name || this.$route.query.own_name;
                        this.getList()
                    }
                    if(this.$route.query.status){//需要监听的参数
                        this.worker_status = this.$route.query.status
                        this.activeName = this.$route.query.status
                    }
                }
            },
            chat_params: {
                immediate: true,
                deep: true,
                handler(nVal, oVal) {
                    process.env.NODE_ENV !== 'production' && console.log(oVal,nVal.user_id , this.user_id , nVal.obj_id , this.obj_id)
                    if (oVal && (nVal.user_id != this.user_id || nVal.obj_id != this.obj_id)) {
                        this.user_id = nVal.user_id;
                        this.obj_id = nVal.obj_id;
                        this.friend_name = nVal.friend_name;
                        this.user_name = nVal.own_name;
                        // 获取列表
                        process.env.NODE_ENV !== 'production' && console.log('getList')
                        this.getList();
                    }

                },
            },
        }
    };
</script>

<style scoped>
    #layout {
        text-align: left;
        margin: 15px 0px;
        border: 1px solid rgba(228, 228, 228, 1);
        display: inline-block;
        width: 98%;
        padding: 1rem;
    }

    #docker_user {
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        background-color: rgba(242, 242, 242, 1);
        padding: 2rem 2rem;
        font-size: 20px;
    }

    #docker_user p {
        margin: 0;
        color: #999999;
    }

    #triangle {
        float: left;
        background-color: #9ea7b5;
        height: 60px;
        width: 30%;
        left: 0;
        color: white;
        font-size: 16px;
        padding-left: 1rem;
    }

    #triangle-right {
        float: left;
        /* display:inline-block; */
        width: 0;
        height: 0;
        border-top: 30px solid transparent;
        border-left: 20px solid #9ea7b5;
        border-bottom: 30px solid transparent;
    }
</style>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .msg_timeout.el-table__row{
        background-color: #bed9ff !important;
    }
    .el-table--enable-row-hover .el-table__body tr.msg_timeout:hover>td {
        background-color: #bdd1eb !important;
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
</style>
